export default __webpack_public_path__ + "static/media/manage-profile.4eeb0c07.svg";